// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetNewbuildingValuationBlockWebRequest,
  TGetNewbuildingValuationBlockWebModel,
  IMappers,
  TGetNewbuildingValuationBlockWebResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { INewbuildingValuationResponse } from '../../entities/newbuilding_prices_and_deals/NewbuildingValuationResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingValuationBlockWebModel(
  parameters: TGetNewbuildingValuationBlockWebRequest,
): TGetNewbuildingValuationBlockWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-estimate',
    pathApi: '/v2/get-newbuilding-valuation-block-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetNewbuildingValuationBlockWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetNewbuildingValuationBlockWebRequest;
}

export async function fetchGetNewbuildingValuationBlockWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingValuationBlockWebOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingValuationBlockWebResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingValuationBlockWebModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingValuationBlockWebResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as INewbuildingValuationResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingValuationBlockWebResponse>;
}
